'use strict';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import isNil from 'lodash/isNil';
import isUndefined from 'lodash/isUndefined';
import * as T from 'prop-types';
import React, {Component} from 'react';
import {DropdownView} from './DropdownView';


const DEFAULT_PLACEHOLDER_STRING = 'Select...';

export class DropdownComponent extends Component {
  static propTypes = {
    className: T.string,
    baseClassName: T.string,
    controlClassName: T.string,
    placeholderClassName: T.string,
    menuClassName: T.string,
    arrowClassName: T.string,
    disabled: T.bool,
    value: T.any,
    placeholder: T.string,
    checkIsSelected: T.func,
    getKey: T.func,

    onChange: T.func,
    onFocus: T.func,
  };

  static defaultProps = {
    checkIsSelected: (selectedValue, optionValue) => selectedValue === optionValue,
    getKey: (value) => value,
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: !isNil(props.value) ? props.value : {
        label: isUndefined(props.placeholder)
          ? DEFAULT_PLACEHOLDER_STRING
          : props.placeholder,
        value: '',
      },
      isOpen: false,
    };

    this.setContentRef = this.setContentRef.bind(this);
    this.handleClickBackdrop = this.handleClickBackdrop.bind(this);
    this.fireChangeEvent = this.fireChangeEvent.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSelectOption = this.handleSelectOption.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value && !newProps.checkIsSelected(this.state.selected, newProps.value)) {
      this.setState({selected: newProps.value});
    } else if (!newProps.value) {
      this.setState({
        selected: {
          label: isUndefined(newProps.placeholder)
            ? DEFAULT_PLACEHOLDER_STRING
            : newProps.placeholder,
          value: null,
        },
      });
    }
  }

  setContentRef(content) {
    this.content = content;
  }

  handleClick(event) {
    if (this.props.disabled) return;
    if (this.props.onFocus && isFunction(this.props.onFocus)) {
      this.props.onFocus(this.state.isOpen);
    }
    event.stopPropagation();
    event.preventDefault();

    if (!this.props.disabled) {
      this.setState({
        isOpen: !this.state.isOpen,
        offset: this.content.getBoundingClientRect(),
      });
    }
  }

  handleClickBackdrop(event) {
    event.stopPropagation();
    if (this.state.isOpen) {
      this.setState({isOpen: false});
    }
  }

  fireChangeEvent(newState) {
    const newValue = get(newState.selected, 'value');
    const currentValue = get(this.state.selected, 'value');
    if (isFunction(this.props.onChange) && !this.props.checkIsSelected(newValue, currentValue)) {
      this.props.onChange(newState.selected);
    }
  }

  handleSelectOption(ev, {value, label}) {
    const newState = {
      selected: {
        value,
        label,
      },
      isOpen: false,
    };
    this.fireChangeEvent(newState);
    this.setState(newState);
  }

  render() {
    const props = this.props;
    return (
      <DropdownView
        setContentRef={this.setContentRef}
        offset={this.state.offset}
        className={props.className}
        baseClassName={props.baseClassName}
        controlClassName={props.controlClassName}
        placeholderClassName={props.placeholderClassName}
        menuClassName={props.menuClassName}
        arrowClassName={props.arrowClassName}
        isOpen={this.state.isOpen}
        selected={this.state.selected}
        options={props.options}
        checkIsSelected={props.checkIsSelected}
        getKey={props.getKey}

        onClickBackdrop={this.handleClickBackdrop}
        onClick={this.handleClick}
        onSelectOption={this.handleSelectOption}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Dropdown/DropdownComponent.js